import * as React from "react";
import { DefaultButton, CommandBar, ICommandBarItemProps, TextField, IContextualMenuItem } from "office-ui-fabric-react";
import { RouteComponentProps } from "react-router";
import { getTemplateById, getLanguages, getCollection, getCollections } from "~/state/action";
import { RootState } from "~/state";
import { connect } from "react-redux";
import { Field, Collection, FieldValues, ContentStatus } from "typings";
import { FieldContainer } from "../product/product.style";
import fieldRender from "../product/FieldEditor";
import { CollectionCommandBar } from "./collection.styles";
import { 
    changeCollectionName, 
    loadCollection, 
    updateCollectionData, 
    deleteCollection, 
    setParentId, 
    updateCollectionStatus 
} 
from "~/state/collection/action";
import { useCallback, useEffect } from "react";
import CollectionPickerDialog from "../product/FieldEditor/collectionPicker/CollectionPickerDialog";
import * as G from "~/components/global.style";
import { getStatusText } from "~/util/productStatus";

interface Props extends RouteComponentProps<{ collectionId: string }>
{
   
}

const CollectionEditor: React.FunctionComponent<Props & StateProps> = props =>
{
    const [parentId, setParentId] = React.useState<string | undefined>(props.collection.parentId);
    const [showCollectionPicker, setShowCollectionPicker] = React.useState(false);
    const collectionId = props.match.params.collectionId;
   
    useEffect(() =>
    {
        props.loadCollection(collectionId);
    }, []);

    useEffect(() =>
    {
        setParentId(props.collection.parentId);
    }, [props.collection.parentId]);
    let collectionNameTimeout: NodeJS.Timeout;
    const onClearField = () => () =>
    {

    };
    const setOrRemoveParentId = useCallback((id: string) => setParentId(id === parentId ? undefined : id), [parentId]);
    const onSaveParentId = useCallback(() =>
    {
        props.setParentId(collectionId, parentId);
        setShowCollectionPicker(false);
    }, [parentId]) ;
    
    const updateCollectionName = (event: any, newValue: string) =>
    {
        clearTimeout(collectionNameTimeout);
        collectionNameTimeout = setTimeout(() => 
        {
            props.changeCollectionName(collectionId, newValue);
        }, 400);
    };

    const onFieldValueChange = (key: string) => (value: FieldValues) =>
    {
        props.updateCollectionData(props.match.params.collectionId, { [key]: value.value });
    };

    const toggleShowCollection = React.useCallback(() =>
    {
        setShowCollectionPicker(!showCollectionPicker);
    }, [showCollectionPicker]);

    const onRemoveClick =  React.useCallback(() =>
    {
        if (confirm("are you sure that you want to remove this collection?"))
        {
            props.deleteCollection(props.match.params.collectionId);
            props.history.push("/collections/");
        }
       
    }, []);

    const onStatusChange = React.useCallback((ev?: React.MouseEvent<HTMLElement>, item?: IContextualMenuItem) =>
    {
        if (item)
        {
            props.changeStatus(props.match.params.collectionId, parseInt(item.key));
        }
        
    }, []);

    const renderField = (field: Field)  =>
    ( 
        <FieldContainer className={"vb-" + field.field.fieldType.id} key={field.field.name}>
            {fieldRender(
                field, 
                props.collection.data ? props.collection.data[field.field.name] : {}, 
                onFieldValueChange(field.field.name),
                props.languages,
                onClearField(),
                false
                )}
        </FieldContainer>
    );

    const renderFields = () =>
    {
        return props.template.fields.map((field, index) =>
        {
            return (
                <div key={index} className="groupedFields">
                    <label>{field.field.label._DEFAULT}</label>
                    <div className={`groupedFields__content`}>
                        {renderField(field)}
                    </div>
                </div>
            );
        });
    };
    if (!props.template || !props.languages || props.languages.length === 0)
    {
        return null;
    }
    const commandBarItems: ICommandBarItemProps[] = [
        {
            key: "collectionName",
            name: "collectionName",
            iconProps: {
                iconName: "Filter"
            },
            
            onRender: () => 
                <TextField width={300} value={props.collection.name}  placeholder="Collection Name" onChange={updateCollectionName} />
        },

    ];
    const status = getStatusText(props.collection.status === undefined ? 0 : props.collection.status);
    const commandBarFarItems: ICommandBarItemProps[] = [{
        key: "Status",
        name: `Status (${status})`,
        className: `status-${status}`,
        iconProps: {
            iconName: "StatusCircleInner"
            
        },
        subMenuProps: {
            items: [
                { key: "0", name: "New", onClick: onStatusChange, 
                iconProps: {iconName: "StatusCircleInner", style: {color: G.ColorUnAvailable}}},
                { key: "1", name: "Working", onClick: onStatusChange, 
                iconProps: {iconName: "StatusCircleInner", style: {color: G.ColorWaiting}}},
                { key: "2", name: "Discontinued", onClick: onStatusChange, 
                iconProps: {iconName: "StatusCircleInner", style: {color: G.ColorUnAvailable}}},
                { key: "16", name: "Ready", onClick: onStatusChange, 
                iconProps: {iconName: "StatusCircleInner", style: {color: G.ColorAvailable}}},
            ],
        },
    },
        {
            
            key: "parentId",
            name: "ParentId",
            iconProps: {
                iconName: "Filter"
            },
            
            onRender: () => 
            {
                let text = "Choose Parent collection";
                if (parentId && props.collections)
                {
                    const parent = props.collections.find(x => x.id === parentId);
                    if (parent)
                    {
                        text = `Parent (${parent.name})`;
                    }
                }
                return <DefaultButton onClick={toggleShowCollection} text={text} />;
            }
        },
        {
            key: "delete",
            name: "delete",
            iconProps: {
                iconName: "Filter"
            },
            
            onRender: () => <DefaultButton onClick={onRemoveClick} text="Remove Collection" />
        },
    ];
    let collectionDialog = null;
    if (showCollectionPicker)
    {
      
     
        collectionDialog = <CollectionPickerDialog
            collections={props.collections}
            onDismissClick={toggleShowCollection}
            selectedCollections={parentId ? [parentId] : []}
            value={ { type: "collection" } }
            addOrRemoveFromCollection={setOrRemoveParentId}
            onSave={onSaveParentId}
            />;
    }
    return (
        <div>
             <CollectionCommandBar >                    
                <CommandBar items={commandBarItems} farItems={commandBarFarItems} />                
            </CollectionCommandBar>
            {renderFields()}
            {collectionDialog}
        </div>
    );

};


const mapStateToProps = (state: RootState, ownProps: Props) =>
{
    const id = ownProps.match.params.collectionId;
    let collections: Collection[] = getCollections(state);
    let collection: Partial<Collection> = getCollection(state, id);
    
    if (collection === undefined)
    {
        collection = {};
    }
    if (collections)
    {
        collections = collections.filter(x => x.id !== id);
    }
    return {
        template:  getTemplateById(state, "COLLECTION_TEMPLATE"),
        languages: getLanguages(state),
        collections,
        collection
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    loadCollection: (id: string) => dispatch(loadCollection(id)),
    deleteCollection: (id: string) => dispatch(deleteCollection(id)),
    changeCollectionName: (id: string, name: string) => dispatch(changeCollectionName(id, name)),
    updateCollectionData: (id: string, data: {[key: string]: any}) => dispatch(updateCollectionData(id, data)),
    setParentId:  (id: string, parentId?: string) => dispatch(setParentId(id, parentId)),
    changeStatus: (id: string, status: ContentStatus) => dispatch(updateCollectionStatus(id, status)),
});
type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(CollectionEditor);


// WEBPACK FOOTER //
// ./src/components/collection/CollectionEditor.tsx